// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.websiteContacts {
  background-color: var(--contacts-bg-color);
  color: var(--contacts-text-color);
  font-size: var(--contacts-font-size-mobile);
}
@media (min-width: 1200px) {
  .websiteContacts {
    font-size: var(--contacts-font-size-desktop);
  }
}
@media (min-width: 768px) {
  .websiteContacts__container {
    padding-left: 70px;
    padding-right: 70px;
  }
}
.websiteContacts.centered {
  text-align: center;
}
.websiteContacts a,
.websiteContacts .FAQ_POPUP-action,
.websiteContacts .TOS_POPUP-action {
  color: var(--contacts-link-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Contacts/Contacts.scss"],"names":[],"mappings":"AAEA;EACI,0CAAA;EACA,iCAAA;EACA,2CAAA;AADJ;AAGI;EALJ;IAMQ,4CAAA;EAAN;AACF;AAGQ;EADJ;IAEQ,kBAAA;IACA,mBAAA;EAAV;AACF;AAGI;EACI,kBAAA;AADR;AAII;;;EAGI,4CAAA;AAFR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
